(function(){
    angular
        .module('app')
        .directive('ngSlugifyform', slugifyForm);

        slugifyForm.$inject = ['$timeout'];
        function slugifyForm($timeout){
            return {
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                    var name = $element.attr("id");
                    var valuesArray = [];
                    var valorDentro = true;
                    //console.log("slug");

                    $.fn.selectRange = function(start, end) {
                    if(end === undefined) {
                        end = start;
                    }
                    return this.each(function() {
                            if('selectionStart' in this) {
                                this.selectionStart = start;
                                this.selectionEnd = end;
                            } else if(this.setSelectionRange) {
                                this.setSelectionRange(start, end);
                            } else if(this.createTextRange) {
                                var range = this.createTextRange();
                                range.collapse(true);
                                range.moveEnd('character', end);
                                range.moveStart('character', start);
                                range.select();
                            }
                        });
                    };

                    $element.on('keyup', function(e) {
                        ////console.log($element.val());
                        //console.log("keyup");
                        var posicionInput = e.target.selectionEnd;
                        var valor = $element.val();
                        $element.val(valor.toLowerCase().replace("á","a").replace("ñ","n").replace("é","e").replace("í","i").replace("ó","o").replace("ú","u").replace("à","a").replace("è","e").replace("ò","o").replace(/ /g,'_').replace(/-/g,'_').replace(/[^a-z0-9_]/g,function(a,e,i){
                           if(!e && a==':')
                                   return '';
                               posicionInput--;
                           return '';
                        }));
                        $element.selectRange(posicionInput);
                    });
                });
            }
          }
      }
})();